import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { DomainService } from './services/domain';
import { Token } from './services/token';
import { AuthService } from './services/auth';
import { SessionService } from './services/session';
import { map } from 'rxjs';

export const domainResolver: ResolveFn<any> = () => {

  const domainService = inject(DomainService);
  const tokenService = inject(Token);
  const authService = inject(AuthService);
  const sessionService = inject(SessionService);

  const input = {
    Route: 'adms_form',
    Domain: window.location.host
  };

  return domainService.getDomainDetails(input).pipe(
    map((res: any) => {

      if (res?.Token) {
        tokenService.setToken(res.Token);
        authService.setTokenFromDomain(res.Token);
      }

      // Always repopulate domain context from resolver output.
      // This avoids missing Org/Zone/Branch when domain response comes from cached replay.
      sessionService.setDomainDetails(res);
      sessionService.setSession(res);

      return res;
    })
  );

};
